export default function formatDate(val, format){
    if (val !== "" && val !== undefined){
        const monthNames = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ];

        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

        let arrDate, hoursDate, newFormat
        if(format !== 5){
             arrDate = val.split("-")
             hoursDate = (arrDate[2].split("T").includes("T")) ?  arrDate[2].split("T") : (arrDate[2].includes(" ")? arrDate[2].split(" ") : [])

             newFormat =  arrDate[1]+'/'+arrDate[2]+'/'+arrDate[0];
             if(hoursDate.length > 0){
                 newFormat = arrDate[1]+'/'+hoursDate[0]+'/'+arrDate[0]+" "+hoursDate[1]  ;
             }
        }

        let date
        switch (format){
            case 1:
                date = new Date(newFormat.replace(".000Z", ""))
                return  `${monthNames[date.getMonth()]} ${date.getDate()} ${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
            case 2:
                if(val.includes(".000z")){
                    date = new Date(newFormat.replace(".000Z", ""))
                    return   `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()} `
                }else if(val.includes(".00000")){
                    date = new Date(newFormat.replace(".000000", ""))
                    return   `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()} `
                }

                date = new Date(newFormat)
                return   `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()} `
            case 3:
                date = new Date(newFormat.replace(".000Z", ""))
                return`${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
            case 4:
                date = new Date(newFormat.replace(".000Z", ""))
                return  `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}, ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`
            case 5:
                date = new Date(val)
                return `${days[date.getDay()]}, ${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`
        }
    }else{
        return ""
    }

}